'use client';
import { useRef } from 'react';
import Link from 'next/link';
import Slider from 'react-slick';
import { PromotionsCard } from '@/components/pages/promotions/PromotionsPage/PromotionsCard/PromotionsCard';
import { Button } from '@/components';
import { SvgArrowLeft, SvgArrowRight } from '@/components/icons';
import { PromotionItem } from '@/api/promotions/promotions.types';
import s from './PromoSlider.module.scss';

interface Props {
  slides: PromotionItem[];
  title?: string;
}

const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1256,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export const PromoSlider = ({ slides, title }: Props) => {
  const sliderRef = useRef<Slider | null>(null);

  return (
    <section className={s.promoSection}>
      <div className={'custom-container'}>
        <div className={s.promoSection__head}>
          <h2 className={s.promoSection__title}>{title || 'Акции'}</h2>
          <div className={s.promoSection__navButtons}>
            <Button
              onClick={() => sliderRef.current?.slickPrev()}
              name=""
              type="button"
              theme="arrow"
              size="small"
              leftIcon={<SvgArrowLeft />}
            />
            <Button
              onClick={() => sliderRef.current?.slickNext()}
              name=""
              type="button"
              theme="arrow"
              size="small"
              leftIcon={<SvgArrowRight />}
            />
          </div>
        </div>
        <div className={s.sliderWrapper}>
          <Slider ref={sliderRef} {...settings}>
            {slides.map((item) => {
              return <PromotionsCard key={item.id} card={item} forSlider className={s.promoSection__slide} />;
            })}
          </Slider>
        </div>
        <Link href={'/promotions'} className={s.promoSection__showAllButton}>
          Посмотреть все акции
        </Link>
      </div>
    </section>
  );
};